export enum LoginIconType {
    Google
};
export interface LoginIconProps {
    type: LoginIconType;
};